import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();


const getWeekendHolidaysList = (data) => {
  return http.post("/api/LeaveRequest/GetWeekendHolidaysList", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const applyleaveRequest = (data) => {
  return http.post("/api/LeaveRequest/ApplyleaveRequest", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getLeaveRequest = (data) => {
  return http.post("/api/LeaveRequest/GetLeaveRequest", data, {
    headers: { Authorization: "Bearer " + token },
  });
};


const empLeaveApproveProcess = (data) => {
  return http.post("/api/LeaveRequest/EmpLeaveApproveProcess", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getTeamLRequest = (data) => {
  return http.post("/api/LeaveRequest/GetTeamLRequest", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getRmteam = (data) => {
  return http.post("/User/GetRmteam", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpLeaveDays = (data) => {
  return http.post("/api/LeaveRequest/GetEmpLeaveDays", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpInfo = (data) => {
  return http.post("/User/GetEmpInfo", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateleaveRequest = (data) => {
  return http.post("api/LeaveRequest/UpdateleaveRequest", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteleaveRequest = (data) => {
  return http.post("api/LeaveRequest/DeleteleaveRequest", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const empLeaveRejectByRM = (data) => {
  return http.post("api/LeaveRequest/EmpLeaveRejectByRM", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const empLeaveRevoke = (data) => {
  return http.post("api/LeaveRequest/EmpLeaveRevoke", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpLeaveDayslist = (data) => {
  return http.post("api/LeaveRequest/GetEmpLeaveDayslist", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getReconciliationReq = (data) => {
  return http.post("api/LeaveRequest/GetReconciliationReq", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getReconciliationByReq = (data) => {
  return http.post("api/LeaveRequest/GetReconciliationByReq", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateLeaveReconciliation = (data) => {
  return http.post("api/LeaveRequest/LeaveReconciliation", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getLeaveCategory = () => {
  return http.get("/api/LeaveRequest/GetLeaveCategory", {
    headers: { Authorization: "Bearer " + token },
  });
};


const getTeamLeadDetail = (data) => {
  return http.post("/api/LeaveRequest/GetTLDetail", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getHRDetail = (data) => {
  return http.post("/api/LeaveRequest/GetHRDetail", data, {
    headers: { Authorization: "Bearer " + token },
  });
};



// below are old apis
// Apply For Mode
// const applyForMode = (data) => {
//   return http.post("/api/LeaveHistory/AddWorkMode", data, {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

// Apply Leave
// const getLeaveTypeList = () => {
//   return http.get("/api/LeaveRequest/GetLeavetype", {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

// const getEmployeeListForCC = () => {
//   return http.get("/api/LeaveRequest/GetEmployeesList", {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

// const getWorkedDaysList = (data) => {
//   return http.post("/api/LeaveRequest/GetWorkedDatesList", data, {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

// const getEmpLeaveRequests = (data) => {
//   return http.post("/api/LeaveRequest/e_getLeavesTblView", data, {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

// const getEmpLeaveRequestById = (data) => {
//   return http.post("/api/LeaveRequest/e_getLeavesTblView", data, {
//     headers: { Authorization: "Bearer " + token },
//   });
// };

const LeaveHistoryService = {
  getWeekendHolidaysList,
  applyleaveRequest,
  getLeaveRequest,
  empLeaveApproveProcess,
  getTeamLRequest,
  getRmteam,
  getEmpLeaveDays,
  getEmpInfo,
  updateleaveRequest,
  deleteleaveRequest,
  empLeaveRejectByRM,
  empLeaveRevoke,
  getEmpLeaveDayslist,
  getReconciliationReq,
  getReconciliationByReq,
  updateLeaveReconciliation,
  getLeaveCategory,
  getTeamLeadDetail,
  getHRDetail,

  // below old
  // applyForMode,
  // getLeaveTypeList,
  // getEmployeeListForCC,
  // getWorkedDaysList,
  // getEmpLeaveRequests,
  // getEmpLeaveRequestById,
};

export default LeaveHistoryService;
